import { toRem, toRems } from "../../../../helpers/theme";

const style = ({ theme, hasLabel, labelAlignLeft, labelWidth, size, isRadioCard }) => {
    const config = {
        groupSpacing: {
            small: {
                top: 2,
            },
            normal: {
                top: 1,
            },
            large: {
                top: 1,
            },
        },
    };

    return {
        position: "relative",
        margin: 0,
        padding: 0,
        display: "flex",
        flexDirection: "column",
        width: "100%",
        [theme.breakpoints.up("md")]: {
            ...(labelAlignLeft && {
                flexDirection: "row",
                alignItems: "flex-start",
            }),
        },
        "& .radioGroup": {
            "&_label": {
                [theme.breakpoints.up("md")]: {
                    ...(labelAlignLeft && {
                        textAlign: "right",
                        marginBottom: 0,
                        paddingTop: 0,
                    }),
                    ...(labelWidth && {
                        maxWidth: toRem(labelWidth),
                        width: "100%",
                    }),
                },
            },
            "&_outer": {
                display: "flex",
                flexDirection: "column",
                flex: 1,
                paddingLeft: isRadioCard && !hasLabel ? 0 : toRem(22),
                [theme.breakpoints.up("md")]: {
                    paddingLeft: isRadioCard && !hasLabel ? 0 : toRem(22),
                    ...(hasLabel &&
                        labelAlignLeft && {
                            padding: toRems([config.groupSpacing[size]?.top, 0, 0, 0]),
                        }),
                },
            },
            "&_list": {
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                flexWrap: "wrap",
                margin: toRems([0, 0, -10, 0]),
                li: {
                    display: "flex",
                    alignItems: "flex-start",
                    margin: toRems([0, 20, 10, 0]),
                    ...(isRadioCard && {
                        margin: toRems([0, 10, 10, 0]),
                    }),
                },
            },
            "&_error": {
                paddingLeft: 0,
            },
            "&_help": {
                paddingLeft: 0,
            },
        },
    };
};

export default style;
